const BASE_URL = "https://zonemedia.co/"
const BLOG_BASE_URL = "https://zonemedia.co/bidbox-blog/react-app-directory/"
const Contact_API = BASE_URL + "api/contact.php"
const Blog_API = BLOG_BASE_URL + "blog-api.php"


export {Contact_API,  Blog_API}